import { DatePipe } from '@angular/common';

import { DateFields, DateRange } from '../entities/date-range.entity';
import { PadLeft, ParseDateRangeQuery } from './date-range-query-helper';
import { FormatDate } from './format-date.helper';

const GetDateString = (fields: DateFields, datePipe: DatePipe) => {
    const year: string | null = PadLeft(fields.Year, 4);
    const month: string | null = PadLeft(fields.Month, 2);
    const day: string | null = PadLeft(fields.Day, 2);

    if (!year) {
        return null;
    }

    if (!month) {
        return FormatDate(datePipe, `${year}-01-01`, 'yyyy');
    }

    if (!day) {
        return FormatDate(datePipe, `${year}-${month}-01`, 'MMM yyyy');
    }

    return FormatDate(datePipe, `${year}-${month}-${day}`);
};

export const TranslateDateRangeQuery = (
    query: string,
    fromLabel: string,
    toLabel: string,
    datePipe: DatePipe
): string => {
    const range: DateRange = ParseDateRangeQuery(query);
    const fromPart: string | null = GetDateString(range.From, datePipe);
    const toPart: string | null = GetDateString(range.Until, datePipe);

    if (fromPart && toPart) {
        return `${fromLabel} ${fromPart} ${toLabel.toLowerCase()} ${toPart}`;
    } else if (fromPart) {
        return `${fromLabel} ${fromPart}`;
    } else if (toPart) {
        return `${toLabel} ${toPart}`;
    } else {
        return '';
    }
};
